import {
  Container,
  Divider,
  Button,
  Grid,
  GridItem,
  Spinner,
  Box,
  useColorModeValue,
} from '@chakra-ui/react';
import Breadcrumbs from '../../common/Breadcrumbs';
import EmptyState from '../../common/EmptyState';
import EmptyDefaultSvgAnimated from '../../theme/illustrations-animated//EmptyDefaultSvgAnimated';
import EmptyDefaultDarkSvgAnimated from '../../theme/illustrations-animated//EmptyDefaultDarkSvgAnimated';
import PassDownloadTemplatesHeader from '../../components/client/pass-download-template/PassDownloadTemplatesHeader';
import useOrganizationStatus from '../../hooks/useOrganisationStatus';
import PassDownloadTemplatesListItem from '../../components/client/pass-download-template/PassDownloadTemplatesListItem';

function PassDownloadTemplatesViewPage({
  items,
  isLoading,
  hasMore,
  loadMore,
  filtersApplied,
  setInputSearch,
}) {
  const modeEmptySvgIcon = useColorModeValue(
    <EmptyDefaultSvgAnimated />,
    <EmptyDefaultDarkSvgAnimated />
  );
  const { shouldRender, components } = useOrganizationStatus(modeEmptySvgIcon);

  const breadcrumbLinks = [
    {
      linkName: 'Home',
      linkUrl: '/',
    },
    {
      linkName: 'pass download pages',
      linkUrl: null,
    },
  ];

  let totalNumberOfPassDownloadPages = items.length;

  return (
    <Container display="flex" flexDir="column" flex="1" pb={6}>
      <Breadcrumbs breadcrumbLinks={breadcrumbLinks} />
      <PassDownloadTemplatesHeader setInputSearch={setInputSearch} />
      <Divider borderColor="primaryBackground" mb={6} />

      {components}
      {totalNumberOfPassDownloadPages > 0 && (
        <>
          <Grid
            templateColumns={{
              base: 'repeat(auto-fill, 320px)',
              sm: 'repeat(auto-fill, 500px)',
            }}
            justifyContent={{
              base: 'center',
              xl: totalNumberOfPassDownloadPages > 1 ? 'center' : 'flex-start',
            }}
            gridColumnGap={{
              base: '64px',
              xl: '35px',
              '2xl': '64px',
            }}
            gridRowGap="45px"
          >
            {items.map((previewData, index) => {
              return (
                <GridItem key={index}>
                  <PassDownloadTemplatesListItem previewData={previewData} />
                </GridItem>
              );
            })}
          </Grid>
          {!isLoading && hasMore && (
            <Box mt="30px" textAlign="center">
              <Button
                alt="Load more templates"
                size="sm"
                onClick={(e) => {
                  e.preventDefault();
                  loadMore();
                }}
              >
                Load more pages
              </Button>
            </Box>
          )}
        </>
      )}
      {isLoading && shouldRender && (
        <>
          <Spinner
            width="52px"
            height="52px"
            thickness="4px"
            speed="0.65s"
            emptyColor="quinaryBackground"
            mt={4}
            mx="auto"
          />
        </>
      )}

      {shouldRender &&
        !isLoading &&
        totalNumberOfPassDownloadPages === 0 &&
        filtersApplied && (
          <EmptyState
            iconSvgAnimated={modeEmptySvgIcon}
            heading="No results found."
            text="Try adjusting your filters to find the pass download pages that you are looking for."
          />
        )}
    </Container>
  );
}

export default PassDownloadTemplatesViewPage;
